var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdCampaignFormBase',{attrs:{"ad-campaign-entry":_vm.adCampaign,"save-loading-entry":_vm.createLoading},on:{"item:submit":_vm.submitEventHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }